import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment'
import { Globals } from "./global";
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AgoraConfigService } from "src/AgoraConfigService";

@Injectable({ providedIn: 'root' })
export class UserService {
    headers:any;
  agoraConfigObject: any;
    constructor(private http: HttpClient,private global:Globals, private agoraConfig: AgoraConfigService) {
      this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
      this.headers = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8')
      //.set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
      
    }

     //Method to fetch meeting Information
     public checkEmailExists(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'checkEmailExists',jsonReq, { headers: this.headers,observe: 'response'});
      }
      //Method to fetch meeting Information
     public saveUser(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'savNewUser',jsonReq, { headers: this.headers,observe: 'response'});
      }
      public userDetailsForCompany(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'userDetailsForCompany',jsonReq, { headers: this.headers,observe: 'response'});
      }

      public updateForActiveUser(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'updateForActiveUser',jsonReq, { headers: this.headers,observe: 'response'});
      }
      
      public fetchUsersCalendar(userId: any) {
        return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+ 'getUserCalendarInfo' +"/"+ userId, { headers: this.headers,observe: 'response'});
      }
      public fetchPasswordDetails(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'getPasswordDetailsOfUser',jsonReq, { headers: this.headers,observe: 'response'});
      }
      public updatePasswordDetails(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'updatePasswordDetails',jsonReq, { headers: this.headers,observe: 'response'});
      }
      public forgotPasswordSecQues(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'retrievePassword',jsonReq, { headers: this.headers,observe: 'response'});
      }
      public getUserDetails(userId: any) {
        return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+ 'getUserInfo' +"/"+ userId, { headers: this.headers,observe: 'response'});
      }
      public saveEditProfile(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+ 'saveEditProfile' ,jsonReq, { headers: this.headers,observe: 'response'});
      }
      public updateWebPref(userId: any,json :any) {
        return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+ 'updateWebPreference' +"/"+ userId , json, { headers: this.headers,observe: 'response'});
      }
      public updatePersonalCalendar(userId: any,json :any) {
        return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+ 'updatePersonalCalendar' +"/"+ userId , json, { headers: this.headers,observe: 'response'});
      }

      //method to get repoting user service
      getReportingUsers(jsonReq: any) {
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}` + "fetchReportingUsers", jsonReq, { headers: this.headers,observe: 'response' })
      };

      // method to fetch the fetchReportingUsers
      fetchReportingUsers(reload:any,userLoginName:any) {
        return new Promise(async(resolve, reject) => {
          if (reload == "Y" || this.global.repotingUsers.length <= 0) {
            var req={"userLoginname":userLoginName}
            await  this.getReportingUsers(req).subscribe((repotingUsersResp: any) => {
              this.global.repotingUsers = repotingUsersResp.body.reportingUserId;
              resolve(this.global.repotingUsers);
            });
          } 
          else {
            resolve(this.global.repotingUsers);
          }
        });
    }
    //method to fetch existing company name
    public checkCompanyExists(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'loadCorpNameList',jsonReq, { headers: this.headers,observe: 'response'});
    }

    public fetchAdminDetails(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'fetchAdminUserId',jsonReq, { headers: this.headers,observe: 'response'});
    }

    getRoleRights(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'getRoleRights',jsonReq, { headers: this.headers,observe: 'response'});
    }
  
    fetchUserMeetingRoleRights(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'fetchUserMeetingRoleRights',jsonReq, { headers: this.headers,observe: 'response'});
    }

    fetchCalendarInfo(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'fetchUserCalendarInfo',jsonReq, { headers: this.headers,observe: 'response'});
    }
    saveUserWebConf(jsonReq: any) {
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.zoom}`+'saveUserWebConfDetails',jsonReq, { headers: this.headers,observe: 'response'});
    }
    checkUserWebConfExists(jsonReq:any){
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.zoom}`+'checkUserWebConfExists',jsonReq, { headers: this.headers,observe: 'response'});
    }

}
  
